import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';

import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import LanguageStore from '../../../store/LanguageStore';
import useTopHeadScript from '../../../hooks/dom/useTopHeadScript';

const ServiceFormWidget = ({ configStore, languageStore }) => {
  if (!configStore.integrations.serviceForm.enabled) {
    return null;
  }

  // Bail if we are in SSR.
  if (typeof document === 'undefined') {
    return null;
  }

  const activeLocale = languageStore.activeLocale;
  if (typeof window !== 'undefined' && activeLocale) {
    window.sfCookieLocale = activeLocale;
  }

  useEffect(() => {
    if (!activeLocale) {
      return undefined;
    }
    window.sfCookieLocale = activeLocale;
    if (window.sf_cc && typeof window.sf_cc.refreshLocale === 'function') {
      window.sf_cc.refreshLocale();
    }
    return undefined;
  }, [activeLocale]);

  useTopHeadScript({
    url: '/vendor/sf-privacy-partner.min.js?v=nethit',
  });

  return <noscript>You need to enable JavaScript</noscript>;
};

ServiceFormWidget.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  languageStore: modelOf(LanguageStore).isRequired,
};

export default inject(
  'configStore',
  'languageStore'
)(observer(ServiceFormWidget));
